module.exports = __webpack_public_path__ + "static/media/specs.af55239b.svg";